var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.active)?_c('div',{staticClass:"loading-circle"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"circle-bg"}),_c('div',{staticClass:"circle"})])
}]

export { render, staticRenderFns }